import React from 'react'
import PageContent from 'components/common/PageContent'
import AppConfigsTable from 'components/organisation/appConfigs/AppConfigsTable'

export default function AppConfigs(props) {

    const pathElements = [
        {id: 0, title: "Home", url: "/"},
        {id: 1, title: "Organisation", url: "/organisation"},
        {id: 2, title: "App Configs"}
    ];

    return (
        <PageContent pathElements={pathElements}>
            <AppConfigsTable />
        </PageContent>
    )
}